/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// import { useParams } from 'react-router-dom';
import {
  emailRegex,
  notification,
  // NUMBER_OF_USERS,
  passwordRegex,
  ROUTES,
} from '../../../assets/constants/strings';
import { registerUser } from '../../../store/User/userActions';
import { REGISTER } from '../../../store/User/userTypes';
import AuthLoader from '../../Loader/Auth';
import '../style.scoped.scss';
// import PhoneNumberInput from '../PhoneNumberInput';
// import { isValidPhoneNumber } from 'react-phone-number-input';
import config from '../../../config';

const SignUpForm = ({
  user,
  handleUserJoined,
  registerUser,
  loading,
  isSmallScreen,
  handleQuoteModal,
  handleChange,
  numberOfUsers,
  showQuoteModal,
}) => {
  // form data
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');

  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState('');
  const [showConf, setShowConf] = useState(false);
  const [organisation, setOrganisation] = useState('');

  // const [phone, setPhone] = useState('');
  // const [jobTitle, setJobTitle] = useState('');
  // const [isValidPhone, setIsValidPhone] = useState(true);
  // const [errorMessage, setErrorMessage] = useState('Not a valid phone number.');

  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showConfirmPasswordError, setShowConfirmPasswordError] =
    useState(false);

  // const [showError, setShowError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !emailRegex(email) ||
      !passwordRegex(password) ||
      password !== confirmPassword
    ) {
      notification(
        'danger',
        'Invalid Information.',
        'Please review any fields marked in red.',
        undefined,
        3.5
      );
    } else {
      registerUser({
        firstName: firstName,
        lastName: lastName,
        email: email,
        password: password,
        confirmPassword: confirmPassword,
        accountType: 'individual',
        organisation: organisation,
        // phoneNumber: phone === '' ? null : phone,
        // jobTitle: jobTitle === '' ? null : jobTitle,
        // userTier: numberOfUsers,
      });
    }
  };

  // const onChangeNumber = (phoneNumber) => {
  //   const newPhone = phoneNumber;
  //   if (newPhone === undefined || newPhone === '') {
  //     setIsValidPhone(true);
  //     setShowError(false);
  //     setErrorMessage('');
  //   } else if (newPhone && newPhone.length > 0) {
  //     if (isValidPhoneNumber(newPhone)) {
  //       setIsValidPhone(true);
  //       setPhone(newPhone);
  //       setShowError(false);
  //       setErrorMessage('');
  //     } else {
  //       setShowError(true);
  //       setIsValidPhone(false);
  //       setErrorMessage('Not a valid phone number.');
  //     }
  //   } else setErrorMessage('Please enter your phone number.');
  // };

  // const handleNumber = () => {
  //   if (phone && phone.length > 0) {
  //     if (isValidPhone) setShowError(false);
  //     else setShowError(true);
  //   }
  // };

  useEffect(() => {
    if (user && user.request === REGISTER && user.success === true)
      handleUserJoined();
    else if (user && user.reason && user.request === REGISTER) {
      notification('info', 'Could not register user.', user.reason);
    }
  }, [user]);

  const handlePassword = () => {
    if (passwordRegex(password)) setShowPasswordError(false);
    else setShowPasswordError(true);
  };

  const handleConfirmPassword = () => {
    if (confirmPassword.length > 0) {
      if (password !== confirmPassword) setShowConfirmPasswordError(true);
      else setShowConfirmPasswordError(false);
    }
  };

  return (
    <React.Fragment>
      {/* {!isSmallScreen && (
        <div className='d-flex justify-content-center w-100'>
          <b className='mr-3'>Already have an account?</b>
          <Link to={ROUTES.LOGIN}>{`Sign In`}</Link>
        </div>
      )} */}
      <div className='wf-account__card d-flex justify-content-center align-items-center cardCorporate mt-4'>
        <div className='wf-account__card__create'>
          <form
            onSubmit={handleSubmit}
            className='mt-3 text-center'
            autoComplete='off'
          >
            <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='First Name'
                id='FirstName'
                onChange={(e) => setFirstName(e.target.value)} // .replace(/\s+/g, '-')
                value={firstName}
                maxLength={35}
                required
              />
            </div>
            <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='Last Name'
                id='LastName'
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
                maxLength={35}
                required
              />
            </div>
            <div className='form-group mb-3'>
              <input
                className={`form-control${
                  email.length === 0
                    ? ''
                    : emailRegex(email)
                    ? ' is-valid'
                    : ' is-invalid'
                }`}
                placeholder='Email'
                type='email'
                id='Email'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                maxLength={320}
                required
              />
            </div>
            <div className='form-group mb-3 position-relative'>
              <input
                className={`form-control${
                  password.length === 0
                    ? ''
                    : passwordRegex(password)
                    ? ' is-valid'
                    : ' is-invalid'
                }`}
                placeholder='Password'
                type={showPass ? 'text' : 'password'}
                id='Password'
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
                onBlur={handlePassword}
                onFocus={() => setShowPasswordError(false)}
              />
              {password.length > 0 ? (
                showPass ? (
                  <FaEyeSlash
                    className='password-visibility'
                    title='Hide Password'
                    onClick={() => setShowPass(false)}
                  />
                ) : (
                  <FaEye
                    className='password-visibility'
                    title='Show Password'
                    onClick={() => setShowPass(true)}
                  />
                )
              ) : null}
              {showPasswordError && (
                <span style={{ color: '#dc3545' }}>
                  <b>
                    Your password does not meet the security criteria outlined
                    below. Please review and create a new password.
                  </b>
                </span>
              )}
            </div>
            <div className='form-group position-relative mb-3'>
              <input
                className={`form-control${
                  confirmPassword.length === 0
                    ? ''
                    : confirmPassword === password
                    ? ' is-valid'
                    : ' is-invalid'
                }`}
                placeholder='Confirm Password'
                type={showConf ? 'text' : 'password'}
                id='ConfirmPassword'
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                required
                onBlur={handleConfirmPassword}
                onFocus={() => setShowConfirmPasswordError(false)}
              />
              {confirmPassword.length > 0 ? (
                showConf ? (
                  <FaEyeSlash
                    className='password-visibility'
                    title='Hide Password'
                    onClick={() => setShowConf(false)}
                  />
                ) : (
                  <FaEye
                    className='password-visibility'
                    title='Show Password'
                    onClick={() => setShowConf(true)}
                  />
                )
              ) : null}
              {showConfirmPasswordError && (
                <span style={{ color: '#dc3545' }}>
                  <b>Password does not match.</b>
                </span>
              )}
            </div>
            {/* <div className='form-group mb-3'>
              <select
                required
                className='custom-select mr-sm-2'
                id='select-users'
                onChange={(e) => handleChange(e.target.value)}
                value={numberOfUsers}
                onClick={showQuoteModal ? handleQuoteModal() : null}
              >
                {NUMBER_OF_USERS.map((item, i) => (
                  <option
                    key={i}
                    value={item.value}
                    defaultValue={numberOfUsers}
                  >
                    {item.text}
                  </option>
                ))}
              </select>
            </div> */}
            {/* <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='Job Title (Optional)'
                id='JobTitle'
                onChange={(e) => setJobTitle(e.target.value)}
                value={jobTitle}
                maxLength={35}
              />
            </div> */}
            {/* <div className='form-group mb-3'>
              <PhoneNumberInput
                phoneValue={phone}
                onChangeNumber={(phoneNumber) => onChangeNumber(phoneNumber)}
                showError={showError}
                handleNumberBlur={handleNumber}
                handleNumberFocus={() => setShowError(false)}
                errorMessage={errorMessage}
                placeholderValue='Enter phone number (Optional)'
              />
            </div> */}
            <div className='form-group mb-3'>
              <input
                className='form-control'
                placeholder='Company Name (Optional)'
                id='CompanyName'
                type='text'
                onChange={(e) => setOrganisation(e.target.value)}
                value={organisation}
                // required={true}
              />
            </div>
            <b className='mb-3'>
              Passwords must contain at least 8 characters including 1 Upper
              case character, 1 digit and 1 special character.
            </b>
            <div className='form-group mb-3'>
              <div className='checkbox'>
                <input
                  type='checkbox'
                  className='form-control'
                  id='termsAndConditions'
                  required
                />
                <label htmlFor='termsAndConditions'>
                  I have read and accepted the{' '}
                  <a
                    href={`${config.WordPressURL}terms-conditions`}
                    target='_blank'
                    rel='noreferrer'
                  >
                    {`Terms & Conditions`}
                  </a>{' '}
                  &{' '}
                  <a
                    href={`${config.WordPressURL}privacy-policy/`}
                    target='_blank'
                    rel='noreferrer'
                  >
                    {`Privacy & Cookies policy`}
                  </a>
                  .
                </label>
              </div>
            </div>
            <button
              type='submit'
              // disabled={
              //   (phone && phone !== '' && phone.length > 0 && !isValidPhone) ||
              //   !isValidPhone
              // }
            >
              {loading ? 'Creating Account' : 'Create Account'}
              {loading ? <AuthLoader /> : null}
            </button>
          </form>
          <div className='d-flex justify-content-center w-100 mt-4'>
            <b className='mr-3'>Already have an account?</b>
            <Link to={ROUTES.LOGIN}>{`Sign In`}</Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  loading: state.user.loading,
});

const mapDispatchToProps = { registerUser };

export default connect(mapStateToProps, mapDispatchToProps)(SignUpForm);
